export default {

	// New Account Rrequest - Language strings

	"title_new_account": "New Account Request",
	
	// Account & Rep Section
	"title_account_and_rep_details":"Account & Rep Details",
	"label_account_name": "Account Name",
	"label_business_phone": "Business Phone",
	"label_rep_name": "Rep Name",
	"label_rep_email": "Rep Email",
	"label_customer_email": "Customer Email",
	"label_account_profile": "Account Profile",
	
	// Address Section
	"title_address": "Address",
	"label_country": "Country",
	"label_province": "Province",
	"label_state": "State",
	"label_address_line_1": "Account Address line 1",
	"label_address_line_2": "Account Address line 2",
	"label_city": "City",
	"label_postal_code": "Postal Code",

	// Business Info Section
	"title_business_info": "Business Info",
	"label_agency": "Agency",
	"label_channel": "Channel",
	"label_retailer_website": "Retailer Website Address",
	"label_opening_order_forecast": "Opening Order Forecast (Local currency)",
	"label_opening_year_forecast": "Opening Year Forecast (Local currency)",
	"label_percent_of_business_in_apparel": "% Of Business in Apparel",
	"label_key_brands": "Key Brands In Store",
	"label_image_inside_store": "Inside of store images",
	"label_image_outside_store": "Outside of store images",
	"label_image_type_notice":"Please note the image types currently supported are jpg, jpeg, bmp, png, gif, svg, pdf, and file size is maxed at 5MB",
	
	// Finally
	"label_submit": "Submit",
	"text_new_account_confirmation": "Thank you! Your request has been received.",


	// Credit Applications
	//
	//
	"title_credit_application": "Credit Application",

	//authnet landing

	// Business details section
	"title_business_details": "Business",
	"label_company_name": "Company Name",
	"label_trade_name": "Trade Name",
	"text_approved_website_address_for_online_selling": "Approved Web Address For Online Selling",
	"label_sales_tax_vat": "Sales Tax VAT",
	"label_siren_number": "SIREN #",
	"label_resale_certificate_number": "Resale Certificate Number",
	"label_resale_certificate_upload": "Resale Certificate",
	"text_pst_number_required_for_bc_mb_sk": "If your shipping address is within BC, MB or SK, please provide your PST # to be exempt from provincial tax.",

	// Shipping address different section
	"title_shipping_address": "Shipping Address",
	"label_different_shipping_address": "Do you need a different Shipping Address?",
	"label_shipping_country": "Shipping Country",
	"label_shipping_state": "Shipping State",
	"label_shipping_province": "Shipping Province",
	"label_shipping_line_1": "Shipping Line 1",
	"label_shipping_line_2": "Shipping Line 2",

	// Contact Section
	"title_contact": "Contact Information",
	"label_name_of_owner": "Name of Owner",
	"label_phone": "Phone",
	"label_business_email": "Business Email",
	"title_owner": "Owner/Buyer",

	// Buyer Section
	"title_buyer": "Buyer",
	"label_same_buyer_details": "Is the buyer the same?",
	"label_buyer_name": "Buyer Name",
	"label_buyer_email": "Buyer Email",
	"label_buyer_phone": "Buyer Phone",

	// Billing Contact Section
	"title_billing_contact": "Billing Contact",
	"label_same_billing_contact_details": "Is the billing contact the same?",
	"label_billing_name": "Name",
	"label_billing_email": "Email",

	// Business Section
	"title_business": "Business",
	"label_sales_channel": "Sales Channel",

	// Sales Rep Section
	"title_sales_rep": "Sales Rep",
	"label_sales_rep_name": "Name",
	"label_sales_rep_email": "Email",

	// Company Info Section
	"title_company_info": "Company Info",
	"label_company_type": "Company Type",
	"label_store_type": "Store Type",
	"label_do_you_rent_or_own": "Do you rent or own?",
	"option_rent": "Rent",
	"option_own": "Own",
	"label_monthly": "Monthly",
	"label_number_of_years_owned": "Number of Years Owned",
	"label_lease_expirey": "Lease Expiry Date",
	"label_number_of_stores": "Number of stores",

	// Background Section
	"title_background": "Background",
	"label_have_filed_for_bankruptcy": "Has the owner or the company ever filed for bankruptcy?",
	"label_when_was_bankruptcy_filed": "When was bankruptcy filed?",

	// Payment Section
	"title_payment": "Payment",
	"option_terms_with_saxx": "Terms with SAXX",
	"option_prepayment": "Prepayment",
	"text_prepayment_information": "For prepayment terms, SAXX AR will reach out to collect CC information securely through a customized payment portal link.",
	"text_prepayment_note": "Note - A pre-auth with estimated freight & applicable taxes will be done before order release and final charge will be captured once order is shipped.",
	"title_payment_term_bank": "Bank",
	"label_payment_bank_name": "Bank Name",
	"label_payment_bank_contact_name": "Name of bank contact",
	"label_payment_bank_contact_phone": "Phone of bank contact",

	"label_bank_name": "Bank Name",
	"label_bank_contact": "Name of bank contact",
	"label_bank_phone": "Phone of bank contact",
	"title_supplier": "Supplier References",
	"label_supplier_name_1": "Supplier 1 name",
	"label_supplier_contact_name_1": "Supplier 1 contact name",
	"label_supplier_email_1": "Supplier 1 email",
	"label_supplier_phone_1": "Supplier 1 phone",
	"label_supplier_name_2": "Supplier 2 name",
	"label_supplier_contact_name_2": "Supplier 2 contact name",
	"label_supplier_email_2": "Supplier 2 email",
	"label_supplier_phone_2": "Supplier 2 phone",
	"label_supplier_name_3": "Supplier 3 name",
	"label_supplier_contact_name_3": "Supplier 3 contact name",
	"label_supplier_email_3": "Supplier 3 email",
	"label_supplier_phone_3": "Supplier 3 phone",

	// Notifications Section
	"title_notifications": "Notifications",
	"text_notifications_information": "Notifications for information including invoices and order confirmations",
	"label_use_same_email_for_confirmation_and_invoices": "Use the same email for order confirmation and invoices?",
	"label_notification_emails": "Notification emails",
	"label_invoice_emails": "Invoice emails",
	"label_order_confirmation_emails": "Order confirmation emails",

	// Terms and Conditions Section
	"title_terms_and_conditions": "Terms and Conditions",
	"list_terms_and_conditions_usa": [
		"Written notice of any discrepancies to this invoice must be made within 72 hours of receipt of goods.",
		"Any goods returned without prior approval will be subjected to a 15% re-stocking fee.",
		"A finance charge of 18% per annum will be charge on all accounts past due.",
		"There is a 25.00 charge for any returned cheque.",
		"Shippers responsibility is limited to proof of delivery to carrier.",
		"Written notice of short shipments must be claimed within 72 hours of receipt of goods.",
	],
	"list_terms_and_conditions_canada_and_international": [
		"Interest charge of 1.5% per month will be applied to all invoices not paid by due date.",
		"A charge of $25.00 applies to all NSF & Stop Payment cheques.",
		"Returns must be approved by return authorization number and a 15% handling and restocking charge applies to saleable returns.",
		"Any goods deemed unsatisfactory must be notified within 72 hours of receipt.",
		"In signing this application, buyer agrees that email address will be added to the SAXX Dealer monthly information newsletter distribution list in the event that the application is successful.",
		"In signing this application, buyer agrees to all of the above and hereby grants permission for credit information to be verified by companies and financial institutions that the buyer has specified on this document and others that Saxx Underwear Co. becomes aware of during the credit review process.",
	],
	"list_terms_and_conditions_international": [
	],
	"title_vendor_and_map_policies": "Vendor and MAP Policies",
	"text_vendor_and_map_policies": "In submitting this application, the buyer agrees to the following policies.",
	"label_vendor_policy": "Vendor Policy",
	"label_map_policy": "MAP Policy",
	"title_enter_name_and_position": "Please enter your name and position",
	"text_enter_name_and_position_politely": "To authenticate this submission, please fill in your name and position below. Thank you!",
	"label_legal_name": "Your name",
	"label_legal_position": "Your position",
	"label_legal_i_agree_to_terms_conditions_policies": "I agree to the terms, conditions and policies outlined above.",
	
	// Confimation Message
	"text_credit_application_confirmation": "Your application is being processed, you will be notified by email once we have a result.",

};
